// One counter for the search widget refreshes: the searchDefaultData calls that replace the widget
// values after a search or a browser navigation. A refresh keeps the id it got when it started and
// writes the widget only while that id is still the latest. A newer refresh, or a direct write of
// the widget values (a submit from the widget, a date sync on the details), moves
// the counter on, so a late answer cannot overwrite what the user sees now.
let latestCSWRefreshId = 0;

export const startCSWRefresh = (): number => {
  latestCSWRefreshId += 1;
  return latestCSWRefreshId;
};

export const isLatestCSWRefresh = (refreshId: number): boolean => refreshId === latestCSWRefreshId;

// Call before a direct write of the widget values: every refresh still running is dropped.
export const cancelPendingCSWRefreshes = (): void => {
  latestCSWRefreshId += 1;
};
